import { ampli } from 'lib-shared-tracking';

import { PartnerTrackingEventsProps } from '../partners.types';

export const commonPartnerTrackingEvents = ({
  partnerEvents,
}: PartnerTrackingEventsProps): void => {
  partnerEvents.on('widget:collapse:opened', (payload) =>
    ampli.partnerIntegrationsWidgetCollapseOpened(payload),
  );

  partnerEvents.on('widget:collapse:closed', (payload) =>
    ampli.partnerIntegrationsWidgetCollapseClosed(payload),
  );

  partnerEvents.on('settings:create:submitted', (payload) =>
    ampli.partnerIntegrationsSettingsCreateSubmitted(payload),
  );

  partnerEvents.on('settings:view:delete:canceled', (payload) =>
    ampli.partnerIntegrationsSettingsViewDeleteCanceled(payload),
  );

  partnerEvents.on('settings:view:delete:confirmed', (payload) =>
    ampli.partnerIntegrationsSettingsViewDeleteConfirmed(payload),
  );

  partnerEvents.on('settings:view:delete:requested', (payload) =>
    ampli.partnerIntegrationsSettingsViewDeleteRequested(payload),
  );

  partnerEvents.on('settings:view:change:submitted', (payload) =>
    ampli.partnerIntegrationsSettingsViewSubmitted(payload),
  );

  partnerEvents.on('settings:view:oauth:started', (payload) =>
    ampli.partnerIntegrationsSettingsViewOAuthStarted(payload),
  );

  partnerEvents.on('settings:view:oauth:succeeded', (payload) =>
    ampli.partnerIntegrationsSettingsViewOAuthSucceeded(payload),
  );

  partnerEvents.on('settings:condition:created', (payload) =>
    ampli.partnerIntegrationsConditionCreated(payload),
  );

  partnerEvents.on('settings:condition:updated', (payload) =>
    ampli.partnerIntegrationsConditionUpdated(payload),
  );

  partnerEvents.on('settings:condition:deleted', () =>
    ampli.partnerIntegrationsConditionDeleted(),
  );
};
